import type { ReactNode } from 'react'

type ToastPayload = {
  title?: ReactNode
  description?: ReactNode
  variant?: 'default' | 'success' | 'info' | 'warning' | 'destructive' | 'loading'
}

type ToastFn = (payload: ToastPayload) => unknown

export function extractApiErrorMessage(error: unknown, fallback: string) {
  if (
    typeof error === 'object' &&
    error !== null &&
    'response' in error &&
    typeof error.response === 'object' &&
    error.response !== null &&
    'data' in error.response
  ) {
    const { data } = error.response as {
      data?: {
        message?: string
        error?: { message?: string }
        metadata?: { message?: string }
      }
    }

    if (typeof data?.error?.message === 'string' && data.error.message.trim()) {
      return data.error.message
    }

    if (typeof data?.metadata?.message === 'string' && data.metadata.message.trim()) {
      return data.metadata.message
    }

    if (typeof data?.message === 'string' && data.message.trim()) {
      return data.message
    }
  }

  if (error instanceof Error && error.message.trim()) {
    return error.message
  }

  return fallback
}

export function showMutationSuccess(
  toast: ToastFn,
  description: ReactNode,
  title: ReactNode = 'Sucesso!',
) {
  toast({ title, description })
}

export function showMutationError(
  toast: ToastFn,
  {
    error,
    preferErrorMessage = true,
    title,
    fallbackDescription,
  }: {
    error?: unknown
    preferErrorMessage?: boolean
    title: ReactNode
    fallbackDescription: string
  },
) {
  toast({
    variant: 'destructive',
    title,
    description: preferErrorMessage
      ? extractApiErrorMessage(error, fallbackDescription)
      : fallbackDescription,
  })
}
